import api, { ApiResponse, formatApiError } from './api'
import { CustomOmit } from './types'

export type IPublicComplaint = {
  id: string
  title: string
  description: string
  files: string[]
  name: string | null
  email: string | null
  document: string | null
  created_at: Date
  updated_at: Date
}

export type CreatePublicComplaintRequest = CustomOmit<
  IPublicComplaint,
  'id' | 'created_at' | 'updated_at'
>
type CreatePublicComplaintResponse = Record<string, unknown>

export const createPublicComplaint = async (
  data: CreatePublicComplaintRequest
): Promise<ApiResponse<CreatePublicComplaintResponse>> => {
  try {
    const response = await api.post('/support/public-complaints', data)
    return {
      error: false,
      body: response.data.body
    }
  } catch (error: unknown) {
    return formatApiError(error)
  }
}
